module.exports = __webpack_public_path__ + "static/media/icon1@2x.3f06eb5b.png";